import styled from 'styled-components'

export default styled.tr`
  text-align: center;
`